import { customAxios } from '../../common/customAxios';

// 키 이름은 직거래 리스트 조회 파라미터와 같다.
export interface IDirectDealCurationFilterCondition {
  brand?: string[];
  machineType?: string[];
  rowConfig?: string[];
  minEngineOutputPs?: number;
  maxEngineOutputPs?: number;
  minPrice?: number;
  maxPrice?: number;
  minManufacturedYear?: number;
  maxManufacturedYear?: number;
  minOperationTime?: number;
  maxOperationTime?: number;
  recentDays?: number;
  region?: string[];
  sort?: string;
}

export type DirectDealCurationColorType = 'GREY' | 'BLUE' | 'GREEN' | 'YELLOW' | 'RED';

export interface IDirectDealCuration {
  id: string;
  imageUrl: string;
  color: DirectDealCurationColorType;
  subTitle: string;
  title: string;
  keywords: string[];
  filterCondition: IDirectDealCurationFilterCondition;
  productCount: number;
}

export interface IGetDirectDealCurationsReturn {
  curations: IDirectDealCuration[];
}

export const getDirectDealCurations = (): Promise<IGetDirectDealCurationsReturn> => {
  return customAxios.get('/direct-deal-curations');
};
